import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import { NFT_DETAIL, NFT_BUYERS } from "../constants/urls";
import NFTNav from "../components/NavComponents/NFTNav";
import Card from "../components/desktop/Card";
import ModalBidComponent from "../components/BidComponents/PlaceBidModalComponent";
const CoinGecko = require('coingecko-api');
const CoinGeckoClient = new CoinGecko();

import eventBus from '../utils/globalPubSub';
import { PaymentContext } from '../utils/paymentConfigProvider';

const url = window.location;
let domain = (new URL(url));
domain = domain.origin;

const Mobile = styled.div`
  display: none;
  background: #000;
  @media only screen and (max-device-width: 480px) {
  display: flex;
  height: 96vh;
  flex-direction: column;
  }
`;

const CollectorsTitle = styled.div`
  margin-top: 65px;
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 42px;
  line-height: 90.1%;
  /* identical to box height, or 38px */

  display: flex;
  align-items: center;

  color: #FFFFFF;

  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  text-align: center;
  margin-bottom: 18px;
`;

const Desktop = styled.div`
  display: none;
  background: #000;
  /* @media (min-device-width: 481px) { */
    display: flex;
    flex-direction: column;
    /* height: 100vh; */
    height: 100%;
    /* overflow: hidden; */
  /* } */
`;

const Container = styled.div`
@media (min-device-width: 481px) {
  padding: 12px 120px;
}
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  /* height: 100vh; */
`;


const CollectorAddress = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 90.1%;
  /* identical to box height, or 29px */

  display: flex;
  align-items: center;

  color: #FFFFFF;

  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
`;

const CollectorBoughtTime = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  color: #FFFFFF;

  opacity: 0.4;
`;

const Perks = styled.div`
  font-family: 'Space Mono';
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 90.1%;
  color: #FFFFFF;
`;


const CollectorItemBought = styled.a`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  color: #FFFFFF;

  opacity: 0.4;
`;


const CtaButton = ({ count, img }) => {
  return (
    <a
      onClick={() => {
        setOpen(true);
        console.log(open);
        window.analytics.track('modal_open_cta_clicked', {
          icon: `${img}`,
        })
        
      }}
      style={{ textAlign: "center" }}
    >
      <img src={img} />
      <div style={{ textAlign: "center", marginBottom: 16 }}>{count}</div>
    </a>
  );
};

function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}


export default function NFTDetailPage(props) {
    const forceUpdate = useForceUpdate();
    const [glip, setGlip] = useState({});
    const [data, dataSet] = useState();
  const [videos, videosSet] = useState([]);
  const [activeTab, setActiveTab] = useState('NFT');
  const [perkBanners, setPerkBanners] = useState([]);
  const [collectors, setCollectors] = useState([]);
  const [bids, setBids] = useState([]);
  const [perks, setPerks] = useState([]);
  
  const [isOpen, setIsOpen] = useState(false);
  const [startWithWithdraw, setStartWithWithdraw] = useState(false);
  const [startWithDeposit, setStartWithDeposit] = useState(false);
  const [maticPrice, setMaticPrice] = useState(0);

    const paymentConfig = useRef({});
    
    const setPaymentConfig = (newVal) => {
        paymentConfig.current = newVal;
        forceUpdate();
    }

    
    function openModal() {
        setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  const { username, videoId } = useParams();

    async function fetchMyAPI() {
	// TODO Change endpoint
	console.log('video idddd', videoId)
	let fetchUrl = NFT_DETAIL + username + '/serial/' + videoId;
	if(domain.includes('test.glip') || domain.includes('localhostgg:3000')){
	    fetchUrl += '?test=1'
	}
	let response = await fetch(fetchUrl);
	response = await response.json();
	console.log(response);
        
	setGlip(response.data.video);
	setBids(response.data.bids);
	setPerks(response.data.perks);
	dataSet(response.data);
        setPaymentConfig(response.data.config);
	
    }
    useEffect(() => {
        fetchMyAPI();
  }, []);

    
    useEffect(() => {
        eventBus.on("new-bid-add", (publicAddress) => {
            console.log('new-bid-add')
            fetchMyAPI();
        })
	fetchMyAPI();
        return ()=>{
            eventBus.remove("new-bid-add");
        };
    }, []);


    useEffect(() => {
        CoinGeckoClient.coins.fetch('matic-network', {}).then(data => {
      setMaticPrice(data.data.market_data.current_price.usd);
      console.log(data.data)
    });
  }, []);

  useEffect(() => {
    if (data) {
      var vid = document.getElementsByClassName(`video-0`)[0];
      // vid.play();
    }
  }, [data]);

  if (!data) {
    return <></>;
  }

  const handleWithdrawClicked = ()=> {
    setStartWithDeposit(false);
    setStartWithWithdraw(true);
    setIsOpen(true);
    console.log('handleWithdrawClicked');
  }

  const handleDepositClicked = ()=> {
    setStartWithWithdraw(false);
    setStartWithDeposit(true);
    setIsOpen(true);
    console.log('handleDepositClicked');
  }
  
  const desktop_list = videos.map((item, index) => {
    return (
      <Card maticPrice={maticPrice} topcard={false} index={index} item={item} />
    );
  });

  const perk_list = perkBanners.map((item, index) => {
    return (
      <img src={item.url} style={{margin: 10, height: 458}}/>
    );
  });

  const collectors_list = collectors.map((item, index) => {
    var t = Math.floor((new Date().getTime()/1000 - new Date(item.mintedAt).getTime()/1000)/3600);
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '100%',
        paddingTop: 32,
        paddingBottom: 26,
        borderBottom: '1px solid rgba(255,255,255,0.15)',
      }}>
        <div style={{display: 'flex', flexDirection: 'column',}}>
          <CollectorAddress>0x...{item.owner.substr(item.owner.length - 4)}</CollectorAddress>
          <CollectorBoughtTime>{t}h ago</CollectorBoughtTime>
        </div>
        <CollectorItemBought href={window.location.href + '/' + item.serial} target="_blank">bought #{item.serial}</CollectorItemBought>
      </div>
    );
  });

  const perksList = perks.map((item, index) => {
    //TODO add classname for different types
    return (
      <Perks
        className={`perk-tile perk-${item.id}`}
        style={{
          borderRadius: 100,
          margin: 6,
          padding: '12px 16px',
          }}>
        {item.name}
      </Perks>
    );
  });

  return (
      <PaymentContext.Provider value={paymentConfig.current}>
          
          <Desktop>
              <NFTNav
                  expanded={false}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  username={username}
                  handleWithdrawClicked={()=>{handleWithdrawClicked()}}
                  handleDepositClicked={()=>{handleDepositClicked()}}
                  showTabs={true}
              /> 
              {glip.serial && <Container>
                  {/* NFT tab */}
                  <div style={{display: activeTab == 'NFT' ? 'block' : 'none'}}>
                      <Card maticPrice={maticPrice} topcard={true} index={1} item={glip}
        		    username={username} perks={perks} bids={bids}
                            placeBidClicked={()=>{
                                setStartWithWithdraw(false);
                                setStartWithDeposit(false);
                                setIsOpen(true)}}            
	              />
                      
                  </div>

              </Container>
              }

          </Desktop>
      </PaymentContext.Provider>
  );
}

